export const MONTHLY_ACTUALS = {
  "Bank Charges & Other": {
    "2025-08": 1365,
    "2025-09": 2206,
    "2025-10": 14983,
    "2025-11": 2999,
    "2025-12": -2921,
    "2026-01": -4791,
    "2026-02": -5911
  },
  "Employee Benefits & People": {
    "2025-02": 210,
    "2025-03": 171,
    "2025-04": 3376,
    "2025-05": 6301,
    "2025-06": 7473,
    "2025-07": 7268,
    "2025-08": 25459,
    "2025-09": 66221,
    "2025-10": 28162,
    "2025-11": 20604,
    "2025-12": 46552,
    "2026-01": 31189,
    "2026-02": 72926
  },
  "Facilities & Rent": {
    "2025-08": 66137,
    "2025-09": 64284,
    "2025-10": 74137,
    "2025-11": 67417,
    "2025-12": 71908,
    "2026-01": 81462,
    "2026-02": 107902
  },
  "Furniture & Computer Equipment": {
    "2025-08": 1858,
    "2025-09": 13331,
    "2025-10": 16066,
    "2025-11": -1931,
    "2025-12": 6690,
    "2026-01": 13534,
    "2026-02": 14824
  },
  "Grants (iRAP, SR&ED)": {
    "2025-10": 286,
    "2025-11": -17355,
    "2025-12": -14728,
    "2026-02": -7157
  },
  "Interest Income": {
    "2025-08": -3818,
    "2025-09": -22435,
    "2025-10": -24507,
    "2025-11": -255036,
    "2025-12": -222016,
    "2026-01": -12342,
    "2026-02": -956737
  },
  "Leasehold Improvements": {
    "2025-08": 434350,
    "2025-09": 86901,
    "2025-10": 183706,
    "2025-11": 70890,
    "2026-01": 16734,
    "2026-02": 27204
  },
  "Legal, IP & Audit": {
    "2025-08": 38992,
    "2025-09": 34892,
    "2025-10": 16227,
    "2025-11": 41707,
    "2025-12": 59315,
    "2026-01": 114479,
    "2026-02": 114698
  },
  "Loan Repayment (DEC)": {
    "2025-08": 6247,
    "2025-09": 5525,
    "2025-10": 6772,
    "2025-11": 5826,
    "2025-12": 5487,
    "2026-01": 6160,
    "2026-02": 5398
  },
  "Machinery & Equipment": {
    "2025-08": 21021,
    "2025-09": 81477,
    "2025-10": 36978,
    "2025-11": 34295,
    "2025-12": 3210,
    "2026-02": 19164
  },
  "Professional & Consulting": {
    "2025-02": 2712,
    "2025-08": 3791,
    "2025-09": 39911,
    "2025-10": 10231,
    "2025-11": 17181,
    "2025-12": 58694,
    "2026-02": 5569
  },
  "R&D -- Clinical & Preclinical": {
    "2025-08": 524,
    "2025-09": 113479,
    "2025-10": 136330,
    "2025-11": 59014,
    "2025-12": 184264,
    "2026-01": 60397,
    "2026-02": 48145
  },
  "R&D -- Manufacturing": {
    "2025-05": 3895,
    "2025-06": 4485,
    "2025-07": 21382,
    "2025-08": 159679,
    "2025-09": 398817,
    "2025-10": 188411,
    "2025-11": 362262,
    "2025-12": 283902,
    "2026-01": 153622,
    "2026-02": 135453
  },
  "Rental Deposits": {
    "2025-09": 84801
  },
  "Salaries & Payroll Taxes": {
    "2025-08": 511044,
    "2025-09": 547023,
    "2025-10": 594804,
    "2025-11": 507407,
    "2025-12": 1290432,
    "2026-01": 551427,
    "2026-02": 590533
  },
  "Software, IT & Supplies": {
    "2025-08": 24493,
    "2025-09": 44496,
    "2025-10": 4103,
    "2025-11": 48185,
    "2025-12": 22779,
    "2026-01": 155745,
    "2026-02": 54619
  },
  "Travel & Meals": {
    "2025-08": 319,
    "2025-09": 1327,
    "2025-10": 1657,
    "2025-11": 61357,
    "2025-12": 1683,
    "2026-01": 17800,
    "2026-02": 2936
  },
  "Vendor Deposits": {
    "2025-09": 7808,
    "2025-10": 461206,
    "2025-11": 75092,
    "2025-12": 24373,
    "2026-01": 427841,
    "2026-02": 135137
  }
};
